module.exports = __webpack_public_path__ + "img/co-host.39555b54.svg";